import _ from "lodash";
import { AutoComplete, Button, ComboBox, Component, ComponentOptions, Container, Element, HTML, Label, LabelLabel, NumericInput, TemplateComponent, TextBox } from "../../../app/core/ui";
import * as z from "../../../framework";
import { RightLockable } from "../../components/components/component";
import * as maskUtil from "../../components/mask";
import * as zKendo from "../../core/kendo";
import { ll } from "../../core/ll";
import { emptyFn } from "../../core/util";
import { buildODataKendoParams } from "../../data/buildODataKendoParams";
import { codes } from "../../data/codes";
import * as filter from "../../data/filter";
import * as odata from "../../data/odata";
import * as gridUtil from "../gridUtil";
import K_ListView from "../templates/K_ListView";

export interface ListViewOptions extends ComponentOptions {
    entityType?: string;
    parentId?: string;
    parentEntityType?: string;
    entityAlias?: string;
    headerClasses?: string;
    editableColumnClasses?: string;
    checkCount?: boolean;
    data?: any[];
    maxRows?: number;
    select?: string;
    expand?: string;
    afterRenderTable?: string;
    tableType?: string;
    defaultObservable?: string[];
    editableTemplate: any[];
    addPopupEvents?: any;
    requiredRight?: string;
}

export class ListView extends TemplateComponent {

    options: ListViewOptions & RightLockable;
    zScreen: any;
    data: any;
    container: any;
    checkCount: any;
    observableName: any;
    mainColumn: Component;
    rowTemplate: any[];
    tableDataContainer: any;
    constructor(options: ListViewOptions) {
        super(K_ListView, options);
    }

    preRender() {
        const options = this.options;

        if (options.requiredRight) {
            options.rightLocked = !z.userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                this.recursiveDisable = true;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }

        options.entityAlias = options.entityAlias || options.entityType;
        options.headerClasses = options.headerClasses || "";
        options.editableColumnClasses = options.editableColumnClasses || "";
        this.data = options.data || [];
        this.checkCount = options.checkCount || false;
        options.maxRows = options.maxRows == null ? 4 : options.maxRows;
        options.select = options.select || "";
        options.expand = options.expand || "";
        options.afterRenderTable = options.afterRenderTable || "";
    }

    create() {
        var me = this;
        const args = me.options;
        var container = me.container = $("#" + me.id);
        var schema = z.schemas[me.options.entityType] || z.schemas[args.tableType] || {};

        let components: Component[] = [];
        _.forEach(me.options.editableTemplate, function (component, index) {
            let componentOptions = component.options;
            if (index == 0) {
                me.mainColumn = component;
            }

            var width = componentOptions.valueWidth || componentOptions.labelWidth || "auto";
            if (componentOptions.iconType && me.options.rightLocked != true) {
                width = parseInt(width as string, 10) + 24;
            }

            var columnHeader = new Label({
                classes: `editable-table-header bind-label ${me.options.editableColumnClasses} ${componentOptions.classes}`,
                bindValue: componentOptions.title || componentOptions.label,
                labelWidth: width
            });

            components.push(columnHeader);

            if (componentOptions.bindValue.indexOf(".") != -1) {
                var expand = componentOptions.bindValue.substring(0, componentOptions.bindValue.indexOf("."));

                if (me.options.expand.indexOf(expand) == -1) {
                    if (me.options.expand) {
                        me.options.expand += ", ";
                    }
                    me.options.expand += expand;
                }
            }

            if (me.options.select) {
                me.options.select += ", ";
            }

            me.options.select += componentOptions.bindValue;
        });

        components.push(new HTML({
            HTML: "<div class='add " + (me.options.disabled ? "disabled" : "") + (me.recursiveDisable ? " field-visibility-disabled" : "") + "' title='" + z.ll("Add" + me.options.entityAlias, true) + "'></div>"
        }));

        me.rowTemplate = [];
        _.forEach(me.options.editableTemplate, function (component, index) {
            let componentOptions = component.options;
            componentOptions.valueWidth = componentOptions.valueWidth || 50;
            componentOptions.containerClasses = componentOptions.containerClasses || "editable-table-elem";
            componentOptions.disabled = me.options.disabled;

            if (me.recursiveDisable) {
                componentOptions.containerClasses = `${componentOptions.containerClasses} field-visibility-disabled`;
                componentOptions.classes = `${componentOptions.classes} field-visibility-disabled`;
            }

            component.options = componentOptions;
            var childJson = component;

            if (me.options.rightLocked) {
                componentOptions.iconClasses = undefined;
                componentOptions.iconId = undefined;
                componentOptions.iconType = undefined;
            }

            me.rowTemplate.push(component);
        });

        var headerContainerLayout = new Container({
            classes: `editable-header-container ${me.options.headerClasses}`,
            components: components
        });
        headerContainerLayout.render(container);
        container.append("<div class='editable-data-container'></div>");

        me.tableDataContainer = container.find(".editable-data-container");

        container.find(".add").tie("click", function () {
            me.addRow();
        });

        container.data("editableTable", me);

    }

    bindData(args) {
        var me = this;
        args = args || {};

        if (args.data) {
            me.data = args.data;
            me.renderTable();
            me.container.unmask();
        } else {
            me.container.mask();
            me.options.parentId = args.parentId || me.options.parentId;
            var url = `${me.options.entityAlias}?$filter=${me.options.parentEntityType}Id eq ${me.options.parentId}`;

            if (me.options.select) {
                url += "&$select=" + me.options.select;
            }
            if (me.options.expand) {
                url += "&$expand=" + me.options.expand;
            }
            z.ajax({
                url: url
            }).done(function (response) {
                me.data = response.d.results;
                me.renderTable();
                me.container.unmask();
            });
        }
    }

    private addRow() {
        var me = this;

        if (me.data.length >= me.options.maxRows) {
            return;
        }

        var observable = z.observable({});
        observable.set(me.options.parentEntityType + "Id", me.options.parentId);
        var components: Component[] = [];

        var addEditableRowPopUp = z.controls.popUp({
            id: "AddEditableRow",
            title: z.ll("Add"),
            width: 500,
            overlay: true,
            buttons: [
                {
                    name: "Add",
                    clickEvent: function (e) {
                        var validator = addEditableRowPopUp.get("#addRowContainer").data("kendoValidator");
                        if (!validator.validate()) {
                            e.preventDefault();
                            z.controls.alert({
                                header: z.ll("ValidationIssues"),
                                message: z.util.buildValidationMessage(validator.validationErrors),
                                messageIsHTML: true,
                                type: "danger"
                            });
                            return;
                        }
                        var data = _.pick(observable, me.options.defaultObservable);
                        z.ajax({
                            url: me.options.entityAlias,
                            type: "POST",
                            data: data
                        }).done(function () {
                            me.data = [];
                            me.refresh();
                            me.bindData({ "parentId": me.options.parentId });
                        });
                    }
                },
                {
                    name: z.ll("Cancel")
                }
            ]
        });

        z.bind({ container: addEditableRowPopUp.get("#addRowContainer"), bind: ".bind-label", unbind: true });
        z.bind({ container: addEditableRowPopUp.get("#addRowContainer"), bind: ".bind-value", unbind: true });

        _.forEach(me.options.editableTemplate, function (field, index) {
            field = _.cloneDeep(field);
            components.push(field);
        });

        var guts = new Container({
            id: "addRowContainer",
            components: components
        });
        guts.options.zScreen = addEditableRowPopUp;
        guts.render(addEditableRowPopUp.guts);

        addEditableRowPopUp.get("#addRowContainer").zValidator();

        z.bind({ container: addEditableRowPopUp.get("#addRowContainer"), bind: ".bind-label", data: z.LocalizedLanguage });
        z.bind({ container: addEditableRowPopUp.get("#addRowContainer"), bind: ".bind-value", data: observable });

        me.zScreen[me.options.addPopupEvents] && me.zScreen[me.options.addPopupEvents](addEditableRowPopUp, observable, me.data);

        if (me.data.length >= me.options.maxRows) {
            me.container.find(".add").disable();
        }
    }

    private renderTable() {
        var me = this;
        var autocompletes = me.tableDataContainer.find(".k-autocomplete input");

        _.forEach(autocompletes, function (autocomplete, index) {
            $(autocomplete).data("kendoAutoComplete").destroy();
        });

        var popupContainer = me.get("#addRowContainer");

        popupContainer.empty();

        me.tableDataContainer.empty();

        if (me.data.length == 0) {
            var components: Component[] = [];

            var rowContainerId = `${me.id}_NoItems`;

            components.push(
                new LabelLabel({
                    labelBsc: "col-xs-12",
                    bindLabel: "NoDataWarning"
                })
            );

            var rowContainerLayout = new Container({
                id: rowContainerId,
                type: "Container",
                classes: "editable-row-container col-xs-12",
                components: components
            });

            rowContainerLayout.render(me.tableDataContainer);

            z.bind({ container: "#" + rowContainerId, bind: ".bind-label", data: z.LocalizedLanguage });

        } else {
            _.forEach(me.data, function (row, index) {
                me.renderRow({
                    index: index,
                    row: row
                });
            });
        }

        me.zScreen[me.options.afterRenderTable] && me.zScreen[me.options.afterRenderTable]();
    }

    private renderRow(args) {
        var me = this;
        var row = args.row;
        var index = args.index;

        var observable = z.observable(row);

        var components: Component[] = [];

        var rowContainerId = `${me.id}_Row${index}`;
        observable.rowId = index;

        _.forEach(me.rowTemplate, function (field) {

            field = _.cloneDeep(field);
            field.options.id = rowContainerId + "_" + field.options.id;
            if (field.options.iconId) {
                field.options.iconId = rowContainerId + "_" + field.options.iconId;
            }

            field.options.labelWidth = 0;
            field.options.bsc = " ";
            field.options.valueBsc = " ";
            field.options.labelBsc = " ";
            field.options.label = "";

            components.push(field);
        });

        if (!me.options.rightLocked) {
            components.push(
                new Element({
                    classes: "trash" + (me.recursiveDisable ? " field-visibility-disabled" : ""),
                    containerClasses: me.recursiveDisable ? "field-visibility-disabled" : "",
                    toolTip: "Remove" + me.options.entityAlias,
                    disabled: me.options.disabled
                })
            );
        }

        var rowContainerLayout = new Container({
            id: rowContainerId,
            type: "Container",
            classes: "editable-row-container",
            components: components
        });

        z.bind({ container: "#" + rowContainerId, bind: ".bind-value", unbind: true });
        z.bind({ container: "#" + rowContainerId, bind: ".bind-label", unbind: true });

        rowContainerLayout.render(me.tableDataContainer);

        z.bind({ container: "#" + rowContainerId, bind: ".bind-label", data: z.LocalizedLanguage });
        z.bind({ container: "#" + rowContainerId, bind: ".bind-value", data: observable });

        observable.bind("change", function (e) {
            z.util.updateEntity({
                dto: observable,
                entityType: me.options.entityAlias
            });
        });

        var row: any = $("#" + me.id + "_Row" + index);

        row.find(".trash").tie("click", function () {
            if (me.checkCount) {
                me.container.find(".trash").disable();
                z.ajax({
                    url: "" + me.options.entityAlias + "/" + me.options.entityAlias + "Count/" + me.zScreen[me.observableName].Id,
                    type: "GET"
                }).done(function (countData) {
                    if (countData.d.results > 1) {
                        z.util.deleteEntity({
                            id: observable.Id,
                            entity: me.options.entityAlias,
                            success: function () {
                                var autocompletesToDestroy = me.tableDataContainer.find(".k-autocomplete input");

                                $.each(autocompletesToDestroy, function (i, autocomplete) {
                                    $(autocomplete).data("kendoAutoComplete").destroy();
                                });
                                me.tableDataContainer.empty();
                                me.bindData({ parentId: me.options.parentId });

                                if (!observable.Id) {
                                    z.controls.alert({
                                        header: z.ll("DeleteSuccess"),
                                        message: z.ll("DeleteSuccessMessage").format(z.ll(me.options.entityAlias)),
                                        type: "success"
                                    });
                                }
                            }
                        });
                    } else {
                        z.controls.alert({ type: "danger", header: z.ll("DeleteFailed"), message: z.ll("CannotDeleteLastObject").format(z.ll(me.options.entityAlias)) });
                    }
                    me.container.find(".trash").enable();
                });
            } else {
                z.util.deleteEntity({
                    id: observable.Id,
                    entity: me.options.entityAlias,
                    success: function () {
                        me.bindData({ "parentId": me.options.parentId });
                    }
                });
            }
        });

        if (me.data.length >= me.options.maxRows) {
            me.container.find(".add").disable();
        } else {
            me.container.find(".add").enable();
        }
    }
    private refresh() {
        var me = this;
        var dataContainer = $(`#${me.id} .editable-data-container`);
        var elements = $(dataContainer).find("*");
        _.forEach(elements, function (elem) {
            var element = $(elem);
            var dataNames = Object.keys(element.data());

            _.forEach(dataNames, function (name) {
                if (name.substring(0, 5) == "kendo") {
                    var kendo = element.data(name);
                    if (kendo && kendo.destroy) {
                        kendo.destroy();
                        return false;
                    }
                }
                return true;
            });
        });

        elements.remove();
    }
}
